import Vue from 'vue'
import Element from 'element-ui'
import '../static/css/element-variables.scss'

Vue.use(Element)
